import { ReactNode } from "react"
import cx from "classnames"
import styles from "./index.module.css"

/* Patrón app-data-row del DS 2026 (handoff docs/design-handoff-2026).
   Candidato a componente de librería (hueco nº6): fila label/valor con
   divider, tabular-nums y link externo. */

export const DATA_LIST_DIVIDERS = {
  SOLID: "solid",
  DASHED: "dashed",
} as const

export type DataListDivider = (typeof DATA_LIST_DIVIDERS)[keyof typeof DATA_LIST_DIVIDERS]

export interface DataListItem {
  readonly label: ReactNode
  readonly value: ReactNode
  readonly href?: string
}

interface DataListProps {
  items: readonly DataListItem[]
  divider?: DataListDivider
  className?: string
}

export function DataList({ items, divider = DATA_LIST_DIVIDERS.SOLID, className }: DataListProps) {
  return (
    <dl className={cx(styles.list, styles[divider], className)}>
      {items.map((item, index) => (
        <div className={styles.row} key={index}>
          <dt className={styles.label}>{item.label}</dt>
          <dd className={styles.value}>
            {item.href ? (
              <a className={styles.link} href={item.href} target="_blank" rel="noopener noreferrer">
                {item.value}
                <span aria-hidden="true">↗</span>
              </a>
            ) : (
              item.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  )
}
